import { ErrorHandler, Injectable } from '@angular/core';
import { Logger } from './logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private logger: Logger) {}

  handleError(error: any): void {
    const original = error?.ngOriginalError ?? error;
    this.logger.error('Uncaught error', {
      message: original?.message ?? String(original),
      stack: original?.stack
    });
    // Re-lanza si quieres que Angular lo siga reportando en dev
    if (!window || !(window as any)['__SILENCE_GLOBAL_ERRORS__']) {
      console.error(original);
    }
  }
}
